import { MdSearch } from 'react-icons/md';
import { Icon, IconContainer } from '@nbirl/nbi-common-ui-libs';

export const DashboardsSearchLanding = () => (
  <div className="flex flex-col items-center space-y-2 px-6 py-28">
    <IconContainer variant="light">
      <Icon icon={<MdSearch className="text-primary-500" />} />
    </IconContainer>
    <p className="text-2xl font-medium">Start searching</p>
    <p className="text-center">
      Enter a workbook name or keywords to begin searching.
    </p>
  </div>
);
